import { DataType } from './types';

import QuestionScreen1Form from './QuestionScreen1Form';

type Question4Type = {
	screen: number;
	data: (data: DataType) => void;
	questionNumber: number;
};

export default function Question4(props: Question4Type) {
	const { questionNumber, screen = 1, data } = props;

	if (screen !== 1) return null;

	return (
		<div className={`question-content question-${questionNumber}-content`}>
			<QuestionScreen1Form screen={screen} data={data} questionNumber={questionNumber} />
		</div>
	);
}
